import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import * as $ from 'jquery';
import { ServicesService } from '../../services/public/services.service';
import { AlertesService } from '../../services/public/alertes.service';
import { PublicService } from '../../services/public/public.service';
import { AddPaymentComponent } from '../add-payment/add-payment.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ViewDetailsServicepublicComponent } from '../view-details-servicepublic/view-details-servicepublic.component';
import { FormulaireService } from '../../services/public/formulaire.service';

@Component({
  selector: 'app-complement-form-public',
  templateUrl: './complement-form-public.component.html',
  styleUrls: ['./complement-form-public.component.scss']
})
export class ComplementFormPublicComponent {
   @Input() parentModal: BsModalRef;

    data: any;
    forms: any = [];
    request_field_form;
    loadingServiceForms = true;

    steps_form:any = [];
    lenght_steps : number = 0;
    currentStepIndex: number = 0;
    DEMANDE_KEY_FILES_TO_UPDATE: any = {};
    SERVICE_DEMANDEUR_OPERATION_REF: any = null;
    demandeForm: FormGroup;
    ref_form: any
    op_ref: any
    constructor(private modalService: BsModalService,
      private service : FormulaireService,
      private publicService: PublicService,
      private alerte: AlertesService,
      public bsModalRef: BsModalRef
      ,public options: ModalOptions, private penalService: PenalCourrierService,private formBuilder: FormBuilder,private ngxService: NgxUiLoaderService, private modalRef: BsModalRef) {
      this.data = options.initialState.data;
      this.ref_form = options.initialState.ref_form;
      this.op_ref = options.initialState.operation_ref;

      let dataREF = {
        dynamic_field: this.formBuilder.array([])
      }
      this.demandeForm = this.formBuilder.group(dataREF);
      console.log({'dddddhhh': this.data});


    }

    openModalSuccessDialog(message: string) {
      const config: ModalOptions = {
        initialState: {
          message: message
        }
      };
      this.penalService.hiddeModal(this.parentModal);
      this.modalRef = this.modalService.show(SuccessDialogComponent, Object.assign({}, config, {class:'modal-sm'}));
    }

    closeWithMessage(message: string) {
      this.bsModalRef.hide();
      this.bsModalRef.onHidden.emit(message);
    }

    hidde() {
      if (this.modalRef) {
        this.modalRef.hide();
        this.ngxService.stop();
      }
    }



    async getFormulaires(SERVICE_REF:any) {
      this.ngxService.startLoader('loader-01');
      this.loadingServiceForms = true
      await this.service.getFormInputsOther(SERVICE_REF).subscribe( (res :any) => {

        this.forms= res;
        console.log('getted form request', this.forms)
        this.steps_form = this.forms;

        this.lenght_steps = res.length;

        this.ngxService.stopLoader('loader-01');


      }, (error :any) => {
        this.ngxService.stopLoader('loader-01');
        this.loadingServiceForms = false
        this.alerte.errorNotification('FORMULAIRES',error.error)
      })
    }

    nextStep() {
      this.currentStepIndex++;
    }

    // onFileSelected(event: any,key: any) {
    //   const file = event.target.files[0];
    //   if (file) {
    //     this.readFileAsBase64(file, key);
    //   }
    // }

    readFileAsBase64(file: File, key:any) {
      const reader = new FileReader();
      console.log('IIIIIIIIII')



      reader.onloadend = () => {
        const base64String = reader.result as string;
        this.DEMANDE_KEY_FILES_TO_UPDATE[key]=  base64String
        // Do something with the base64String, such as sending it to the server or displaying it on the page
      };

      reader.readAsDataURL(file);
    }

    // limitation taille fichier:
    onFileSelected(event: Event, key: string) {
      const input = event.target as HTMLInputElement;

      if (input.files && input.files.length > 0) {
        const file = input.files[0];

        // if (file.size > 100 * 1024) { // 100 Ko
        //   alert('La taille du fichier ne doit pas dépasser 100 Ko.');
        //   input.value = '';
        //   $(input).parent().find('.file-label').text('Importer un fichier(taille max. 100ko)');
        //   return;
        // } else {

          const fileName = $(input).val().split("\\").pop();
          $(input).parent().find('.file-label').text(fileName);

          if (file) {
            this.readFileAsBase64(file, key);
          }
        // }

        console.log(`Fichier sélectionné: ${file.name}`);
      }
    }

    closeModal(){
      this.bsModalRef.hide()
    }






    async sendDemande(data_form: any) {
      this.ngxService.startLoader('loader-01')
      let body_content = {
        'operation_ref': this.op_ref,
        'form_ref': this.ref_form,
        'body': data_form.form.value
      }

      if (this.DEMANDE_KEY_FILES_TO_UPDATE) {
        const FILES_UPDATED_KEYS = Object.keys(this.DEMANDE_KEY_FILES_TO_UPDATE);
        for (let key of FILES_UPDATED_KEYS){
          data_form.form.value[key] = this.DEMANDE_KEY_FILES_TO_UPDATE[key]
        }
    
      }
      

      console.log('body_content', body_content);
      
      this.service.sendFormComplementData(body_content).subscribe((res:any)=>{
        this.alerte.successNotification('Complément', 'Informations enregistrées!')
        this.ngxService.stopLoader('loader-01')
        this.closeWithMessage('success')
      },(err:any)=>{
        this.alerte.errorNotification('Complément', 'Erreur lors de l\'enregistrement !')
        this.ngxService.stopLoader('loader-01')
      })



    }

    getFileInputId(formIndex: number, entryKey: string): string {
      return `file-${formIndex}-${entryKey}`;
    }

    async ngOnInit() {
      // console.log({'type courrier': this.data.typeCourrier});

     await this.getFormulaires(this.ref_form);



      setTimeout(() => {

        $(document).ready(function(){
          var current_fs, next_fs, previous_fs; //fieldsets
          var opacity;
          var current = 1;
          var steps = $("fieldset").length;


          setProgressBar(current);
          if ($("fieldset").hasClass("_enrollement")) {
            // Cacher le premier fieldset et afficher le deuxième
            $("fieldset").eq(0).hide();
            $("fieldset").eq(1).show();
            current = 2;

            // Ajouter la classe "active" au deuxième élément de la barre de progression
            $("#progressbar li").eq(1).addClass("active");
            console.log("Au moins un élément fieldset a la classe 'cache'");
          }




          // Fonction pour définir la barre de progression
          function setProgressBar(curStep){
              var percent = (100 / steps) * curStep;
              percent = percent
              $(".progress-bar").css("width",percent+"%");
          }

          // Logique pour passer à l'étape suivante
          $(".next").click(function(){
              current_fs = $(this).parent();
              next_fs = $(this).parent().next();

              // Ajouter la classe "active" à l'étape suivante de la barre de progression
              $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

              // Afficher le fieldset suivant avec une animation
              next_fs.show();
              current_fs.animate({opacity: 0}, {
                  step: function(now) {
                      opacity = 1 - now;
                      current_fs.css({
                          'display': 'none',
                          'position': 'relative'
                      });
                      next_fs.css({'opacity': opacity});
                  },
                  duration: 500
              });
              setProgressBar(++current);
          });

          // Logique pour revenir à l'étape précédente
          $(".previous").click(function(){
              current_fs = $(this).parent();
              previous_fs = $(this).parent().prev();

              // Retirer la classe "active" de l'étape actuelle de la barre de progression
              $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

              // Afficher le fieldset précédent avec une animation
              previous_fs.show();
              current_fs.animate({opacity: 0}, {
                  step: function(now) {
                      opacity = 1 - now;
                      current_fs.css({
                          'display': 'none',
                          'position': 'relative'
                      });
                      previous_fs.css({'opacity': opacity});
                  },
                  duration: 500
              });
              setProgressBar(--current);
          });



      });

        }, 2000);


    }
    get stepWidth(): string {
      // return `${100 / this.forms.length}%`;
      return `${100}%`;

    }


}
